<div class="events-container">
  <div class="events-list">
    <div *ngFor="let event of events()" class="event-item">
      <img [src]="getIconUrl(event)" [alt]="event.title" class="event-icon">
      <div class="event-content">
        <div class="event-title">{{ event.title }}</div>
        <div class="event-subtitle">{{ formatDateTime(event.datetime) }}</div>
      </div>
    </div>
  </div>
</div>